import { configureStore } from "@reduxjs/toolkit";
import profileSlice from './profile/profile.slice'
import { userSlice } from './auth/Loginslice'
import { accountSlice } from './Account/slice'
import performancePersonalLedgerSlice from "./performanceAward/performancePersonalLedger.slice";
import performanceViewAwardDetailSlice from "./performanceAward/performanceViewAwardDetail.slice";
import optionPersonalLedgerSlice from "./OptionAward/optionPersonalLedger.slice";
import optionAcceptOfferDetailSlice from "./OptionAward/acceptOffer.slice";
import contactUsSlice from "./contactUs/contactUs.slice";
import ExcerciseoptionSlice from "./OptionAward/excerciseOption.slice";
import planRulesSlice from "./contactUs/planRules.slice";
import masterSlice from "./Misc/master.slice";
import createGrantSlice from "./Administrator/ESOPGrant/createGrant.slice";
import esopOptionSlice from "./Administrator/ESOPOption/esopOptionDetails.slice";
import pspAwardSlice from "./Administrator/PSPAward/pspAwardDetails.slice";
import esopPersonalLedgerSlice from "./Report/esopPersonalLedger.slice";
import pspReportsSlice from "./Report/pspReports.slice";


//===============|| STORE ||====================//
export const store = configureStore({
    reducer: {
        profile: profileSlice.reducer,
        auth: userSlice.reducer,
        Account: accountSlice.reducer,
        performancePersonalLedger: performancePersonalLedgerSlice.reducer,
        performanceViewAwardDetail: performanceViewAwardDetailSlice.reducer,
        optionPersonalLedger: optionPersonalLedgerSlice.reducer,
        optionAcceptOfferDetail: optionAcceptOfferDetailSlice.reducer,
        contactUs: contactUsSlice.reducer,
        Excerciseoption: ExcerciseoptionSlice.reducer,
        planRules: planRulesSlice.reducer,
        master: masterSlice.reducer,
        creategrant: createGrantSlice.reducer,
        esopoption: esopOptionSlice.reducer,
        pspaward: pspAwardSlice.reducer,
        esopPersonalLedger: esopPersonalLedgerSlice.reducer,
        pspReports: pspReportsSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        })
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

